import { createFileRoute } from "@tanstack/react-router";

import { GrupyProduktowPage } from "@/features/grupy-produktow/page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kartoteka/grupy-produktow")({
	component: GrupyProduktowPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kartoteka.grupy-produktow",
			location.pathname,
		);
	},
});
